import { createSelector, createFeatureSelector } from '@ngrx/store';
import { NavState } from './navigation.reducer';
import {AppState} from "../app.state";

export const selectNavState = createFeatureSelector<NavState>('nav');
export const selectNav = createSelector(
  selectNavState,
  (state: NavState) => state
);
